/**
 * hack mithril的route set方法
 * 为了让切换路由的时候不要自动滚到顶部
 */

const noop = () => {};
const scrollTo = window.scrollTo;
const getTop = (element: Element | null) => (element ? element.getBoundingClientRect().top + window.scrollY : 0);

export default function () {
  const originalSet = m.route.set;

  m.route.set = function (...args: any[]) {
    const originalHref = location.href;
    originalSet.apply(this, args);

    if (location.href == originalHref) {
      return;
    }

    const header = document.querySelector('#header');
    const container = document.querySelector('.sideNavContainer');
    const headerHeight = header?.clientHeight || 0;
    let containerTop = getTop(container);

    if (container) {
      if (window.scrollY > containerTop) {
        window.scrollTo({
          top: containerTop - headerHeight,
          behavior: 'smooth',
        });
      }
      window.scrollTo = noop;
      setTimeout(() => {
        window.scrollTo = scrollTo;
        containerTop = getTop(document.querySelector('.sideNavContainer'));
        if (window.scrollY > containerTop) {
          window.scrollTo({
            top: containerTop - headerHeight,
            behavior: 'smooth',
          });
        }
      }, 100);
    }
  };
}
